// Fallback for react native environments
const envVarMap: Record<string, string | undefined> = {
  NEXT_PUBLIC_DEFAULT_LANGUAGE:
    process.env.NEXT_PUBLIC_DEFAULT_LANGUAGE ??
    process.env.EXPO_PUBLIC_DEFAULT_LANGUAGE,
  NEXT_PUBLIC_DEFAULT_THEME:
    process.env.NEXT_PUBLIC_DEFAULT_THEME ??
    process.env.EXPO_PUBLIC_DEFAULT_THEME,
  NEXT_PUBLIC_ENVIRONMENT:
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? process.env.EXPO_PUBLIC_ENVIRONMENT,
  NEXT_PUBLIC_COMPANY_PREFIX_USERINFO:
    process.env.NEXT_PUBLIC_COMPANY_PREFIX_USERINFO ??
    process.env.EXPO_PUBLIC_COMPANY_PREFIX_USERINFO,
  NEXT_PUBLIC_KILKAYA_CDN_HOST:
    process.env.NEXT_PUBLIC_KILKAYA_CDN_HOST ??
    process.env.EXPO_PUBLIC_KILKAYA_CDN_HOST,
  NEXT_PUBLIC_KILKAYA_INSTALL_ID:
    process.env.NEXT_PUBLIC_KILKAYA_INSTALL_ID ??
    process.env.EXPO_PUBLIC_KILKAYA_INSTALL_ID,
  NEXT_PUBLIC_KILKAYA_HOST_URL:
    process.env.NEXT_PUBLIC_KILKAYA_HOST_URL ??
    process.env.EXPO_PUBLIC_KILKAYA_HOST_URL,
  NEXT_PUBLIC_ORGANIZATION_ID:
    process.env.NEXT_PUBLIC_ORGANIZATION_ID ??
    process.env.EXPO_PUBLIC_ORGANIZATION_ID,
  NEXT_PUBLIC_TENANT_ID:
    process.env.NEXT_PUBLIC_TENANT_ID ?? process.env.EXPO_PUBLIC_TENANT_ID,
  NEXT_PUBLIC_TENANT:
    process.env.NEXT_PUBLIC_TENANT ?? process.env.EXPO_PUBLIC_TENANT,
  NEXT_PUBLIC_CURATED_LIST_ALIAS:
    process.env.NEXT_PUBLIC_CURATED_LIST_ALIAS ??
    process.env.EXPO_PUBLIC_CURATED_LIST_ALIAS,
  NEXT_PUBLIC_REVALIDATE_TIME_SECONDS:
    process.env.NEXT_PUBLIC_REVALIDATE_TIME_SECONDS ??
    process.env.EXPO_PUBLIC_REVALIDATE_TIME_SECONDS,
  NEXT_PUBLIC_ENABLED_LOCALES:
    process.env.NEXT_PUBLIC_ENABLED_LOCALES ??
    process.env.EXPO_PUBLIC_ENABLED_LOCALES,
  NEXT_PUBLIC_SITE_NAME:
    process.env.NEXT_PUBLIC_SITE_NAME ?? process.env.EXPO_PUBLIC_SITE_NAME,
  NEXT_PUBLIC_PAGE_DESCRIPTION:
    process.env.NEXT_PUBLIC_PAGE_DESCRIPTION ??
    process.env.EXPO_PUBLIC_PAGE_DESCRIPTION,
  NEXT_PUBLIC_DESCRIPTION_KEYWORDS:
    process.env.NEXT_PUBLIC_DESCRIPTION_KEYWORDS ??
    process.env.EXPO_PUBLIC_DESCRIPTION_KEYWORDS,
  NEXT_PUBLIC_PUBLISHER_ID:
    process.env.NEXT_PUBLIC_PUBLISHER_ID ??
    process.env.EXPO_PUBLIC_PUBLISHER_ID,
  NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID:
    process.env.NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID ??
    process.env.EXPO_PUBLIC_COGNITO_IDENTITY_POOL_ID,
  NEXT_PUBLIC_COGNITO_USER_POOL_ID:
    process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID ??
    process.env.EXPO_PUBLIC_COGNITO_USER_POOL_ID,
  NEXT_PUBLIC_COGNITO_CLIENT_ID:
    process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID ??
    process.env.EXPO_PUBLIC_COGNITO_CLIENT_ID,
  NEXT_PUBLIC_APP_SCHEME:
    process.env.NEXT_PUBLIC_APP_SCHEME ?? process.env.EXPO_PUBLIC_APP_SCHEME,
  NEXT_PUBLIC_COGNITO_DEVICEFLOW_SECRET_ID:
    process.env.NEXT_PUBLIC_COGNITO_DEVICEFLOW_SECRET_ID ??
    process.env.EXPO_PUBLIC_COGNITO_DEVICEFLOW_SECRET_ID,
  NEXT_PUBLIC_COGNITO_DEVICEFLOW_CLIENT_ID:
    process.env.NEXT_PUBLIC_COGNITO_DEVICEFLOW_CLIENT_ID ??
    process.env.EXPO_PUBLIC_COGNITO_DEVICEFLOW_CLIENT_ID,
  NEXT_PUBLIC_COGNITO_DEVICEFLOW_TENANT:
    process.env.NEXT_PUBLIC_COGNITO_DEVICEFLOW_TENANT ??
    process.env.EXPO_PUBLIC_COGNITO_DEVICEFLOW_TENANT,
  NEXT_PUBLIC_COGNITO_DEVICEFLOW_ENVIRONMENT:
    process.env.NEXT_PUBLIC_COGNITO_DEVICEFLOW_ENVIRONMENT ??
    process.env.EXPO_PUBLIC_COGNITO_DEVICEFLOW_ENVIRONMENT,
  NEXT_PUBLIC_COGNITO_DEVICEFLOW_REFRESH_TOKEN_TENANT:
    process.env.NEXT_PUBLIC_COGNITO_DEVICEFLOW_REFRESH_TOKEN_TENANT ??
    process.env.EXPO_PUBLIC_COGNITO_DEVICEFLOW_REFRESH_TOKEN_TENANT,
  NEXT_PUBLIC_COGNITO_DEVICEFLOW_REFRESH_TOKEN_ENVIRONMENT:
    process.env.NEXT_PUBLIC_COGNITO_DEVICEFLOW_REFRESH_TOKEN_ENVIRONMENT ??
    process.env.EXPO_PUBLIC_COGNITO_DEVICEFLOW_REFRESH_TOKEN_ENVIRONMENT,
  NEXT_PUBLIC_ZEPHYR_HEADER:
    process.env.NEXT_PUBLIC_ZEPHYR_HEADER ??
    process.env.EXPO_PUBLIC_ZEPHYR_HEADER,
  NEXT_PUBLIC_ZEPHYR_FOOTER:
    process.env.NEXT_PUBLIC_ZEPHYR_FOOTER ??
    process.env.EXPO_PUBLIC_ZEPHYR_FOOTER,
  NEXT_PUBLIC_PREVIEW_MARKER_TYPE:
    process.env.NEXT_PUBLIC_PREVIEW_MARKER_TYPE ??
    process.env.EXPO_PUBLIC_PREVIEW_MARKER_TYPE,
  NEXT_PUBLIC_BITMOVIN_PLAYER_KEY:
    process.env.NEXT_PUBLIC_BITMOVIN_PLAYER_KEY ??
    process.env.EXPO_PUBLIC_BITMOVIN_PLAYER_KEY,
  NEXT_PUBLIC_BITMOVIN_ANALYTICS_KEY:
    process.env.NEXT_PUBLIC_BITMOVIN_ANALYTICS_KEY ??
    process.env.EXPO_PUBLIC_BITMOVIN_ANALYTICS_KEY,
  NEXT_PUBLIC_BITMOVIN_WITH_CREDENTIALS:
    process.env.NEXT_PUBLIC_BITMOVIN_WITH_CREDENTIALS ??
    process.env.EXPO_PUBLIC_BITMOVIN_WITH_CREDENTIALS,
  NEXT_PUBLIC_DATADOG_RUM_SAMPLE_RATE:
    process.env.NEXT_PUBLIC_DATADOG_RUM_SAMPLE_RATE ??
    process.env.EXPO_PUBLIC_DATADOG_RUM_SAMPLE_RATE,
  NEXT_PUBLIC_DATADOG_RUM_REPLAY_SAMPLE_RATE:
    process.env.NEXT_PUBLIC_DATADOG_RUM_REPLAY_SAMPLE_RATE ??
    process.env.EXPO_PUBLIC_DATADOG_RUM_REPLAY_SAMPLE_RATE,
  NEXT_PUBLIC_AD_MANIFEST:
    process.env.NEXT_PUBLIC_AD_MANIFEST ?? process.env.EXPO_PUBLIC_AD_MANIFEST,
  NEXT_PUBLIC_MIDROLL_AD_MANIFEST:
    process.env.NEXT_PUBLIC_MIDROLL_AD_MANIFEST ??
    process.env.EXPO_PUBLIC_MIDROLL_AD_MANIFEST,
  NEXT_PUBLIC_AD_TYPE:
    process.env.NEXT_PUBLIC_AD_TYPE ?? process.env.EXPO_PUBLIC_AD_TYPE,
  NEXT_PUBLIC_AD_POSITION:
    process.env.NEXT_PUBLIC_AD_POSITION ?? process.env.EXPO_PUBLIC_AD_POSITION,
  NEXT_PUBLIC_USE_PLAYER_PROFILE_SERVICE:
    process.env.NEXT_PUBLIC_USE_PLAYER_PROFILE_SERVICE ??
    process.env.EXPO_PUBLIC_USE_PLAYER_PROFILE_SERVICE,
  NEXT_PUBLIC_THEME_SWITCHER_ENABLED:
    process.env.NEXT_PUBLIC_THEME_SWITCHER_ENABLED ??
    process.env.EXPO_PUBLIC_THEME_SWITCHER_ENABLED,
  NEXT_PUBLIC_ENABLE_SOCIAL_MEDIA_SHARING:
    process.env.NEXT_PUBLIC_ENABLE_SOCIAL_MEDIA_SHARING ??
    process.env.EXPO_PUBLIC_ENABLE_SOCIAL_MEDIA_SHARING,
  NEXT_PUBLIC_ENABLE_EMBED_CODE_SHARING:
    process.env.NEXT_PUBLIC_ENABLE_EMBED_CODE_SHARING ??
    process.env.EXPO_PUBLIC_ENABLE_EMBED_CODE_SHARING,
  NEXT_PUBLIC_ALTERNATIVE_WATCH_LAYOUT:
    process.env.NEXT_PUBLIC_ALTERNATIVE_WATCH_LAYOUT ??
    process.env.EXPO_PUBLIC_ALTERNATIVE_WATCH_LAYOUT,
  NEXT_PUBLIC_USE_VIDEOJS_PLAYER:
    process.env.NEXT_PUBLIC_USE_VIDEOJS_PLAYER ??
    process.env.EXPO_PUBLIC_USE_VIDEOJS_PLAYER,
  NEXT_PUBLIC_SHOW_PUBLISH_DATE:
    process.env.NEXT_PUBLIC_SHOW_PUBLISH_DATE ??
    process.env.EXPO_PUBLIC_SHOW_PUBLISH_DATE,
  NEXT_PUBLIC_LIVE_PROGRAMS_CATEGORY_ID:
    process.env.NEXT_PUBLIC_LIVE_PROGRAMS_CATEGORY_ID ??
    process.env.EXPO_PUBLIC_LIVE_PROGRAMS_CATEGORY_ID,
  NEXT_PUBLIC_LIVE_ASSET_CATEGORY_ID:
    process.env.NEXT_PUBLIC_LIVE_ASSET_CATEGORY_ID ??
    process.env.EXPO_PUBLIC_LIVE_ASSET_CATEGORY_ID,
  NEXT_PUBLIC_LIVE_ASSET_ID:
    process.env.NEXT_PUBLIC_LIVE_ASSET_ID ??
    process.env.EXPO_PUBLIC_LIVE_ASSET_ID,
  NEXT_PUBLIC_LIVE_CHANNELS_CONFIG:
    process.env.NEXT_PUBLIC_LIVE_CHANNELS_CONFIG ??
    process.env.EXPO_PUBLIC_LIVE_CHANNELS_CONFIG,
  NEXT_PUBLIC_VIPPS_LOGIN_ENABLED:
    process.env.NEXT_PUBLIC_VIPPS_LOGIN_ENABLED ??
    process.env.EXPO_PUBLIC_VIPPS_LOGIN_ENABLED,
  NEXT_PUBLIC_PAYMENTS_ENABLED:
    process.env.NEXT_PUBLIC_PAYMENTS_ENABLED ??
    process.env.EXPO_PUBLIC_PAYMENTS_ENABLED,
  NEXT_PUBLIC_VIPPS_PAYMENTS_ENABLED:
    process.env.NEXT_PUBLIC_VIPPS_PAYMENTS_ENABLED ??
    process.env.EXPO_PUBLIC_VIPPS_PAYMENTS_ENABLED,
  NEXT_PUBLIC_STRIPE_PAYMENTS_ENABLED:
    process.env.NEXT_PUBLIC_STRIPE_PAYMENTS_ENABLED ??
    process.env.EXPO_PUBLIC_STRIPE_PAYMENTS_ENABLED,
  NEXT_PUBLIC_TVOD_ENABLED:
    process.env.NEXT_PUBLIC_TVOD_ENABLED ??
    process.env.EXPO_PUBLIC_TVOD_ENABLED,
  NEXT_PUBLIC_TVOD_PRODUCT_PAYMENT_IDS:
    process.env.NEXT_PUBLIC_TVOD_PRODUCT_PAYMENT_IDS ??
    process.env.EXPO_PUBLIC_TVOD_PRODUCT_PAYMENT_IDS,
  NEXT_PUBLIC_VOUCHER_ENABLED:
    process.env.NEXT_PUBLIC_VOUCHER_ENABLED ??
    process.env.EXPO_PUBLIC_VOUCHER_ENABLED,
  NEXT_PUBLIC_TVOD_PRODUCT_GROUP_ID:
    process.env.NEXT_PUBLIC_TVOD_PRODUCT_GROUP_ID ??
    process.env.EXPO_PUBLIC_TVOD_PRODUCT_GROUP_ID,
  NEXT_PUBLIC_STRIPE_PK:
    process.env.NEXT_PUBLIC_STRIPE_PK ?? process.env.EXPO_PUBLIC_STRIPE_PK,
  NEXT_PUBLIC_STRIPE_ACCOUNT_ID:
    process.env.NEXT_PUBLIC_STRIPE_ACCOUNT_ID ??
    process.env.EXPO_PUBLIC_STRIPE_ACCOUNT_ID,
  NEXT_PUBLIC_PRESELECTED_PRODUCT_GROUP_ID:
    process.env.NEXT_PUBLIC_PRESELECTED_PRODUCT_GROUP_ID ??
    process.env.EXPO_PUBLIC_PRESELECTED_PRODUCT_GROUP_ID,
  NEXT_PUBLIC_PRODUCTION_DOMAIN:
    process.env.NEXT_PUBLIC_PRODUCTION_DOMAIN ??
    process.env.EXPO_PUBLIC_PRODUCTION_DOMAIN,
  NEXT_PUBLIC_MAINTENANCE_MODE:
    process.env.NEXT_PUBLIC_MAINTENANCE_MODE ??
    process.env.EXPO_PUBLIC_MAINTENANCE_MODE,
  NEXT_PUBLIC_ARTWORK_LOGO_ENABLED:
    process.env.NEXT_PUBLIC_ARTWORK_LOGO_ENABLED ??
    process.env.EXPO_PUBLIC_ARTWORK_LOGO_ENABLED,
  NEXT_PUBLIC_LANGUAGE_SWITCHER_ENABLED:
    process.env.NEXT_PUBLIC_LANGUAGE_SWITCHER_ENABLED ??
    process.env.EXPO_PUBLIC_LANGUAGE_SWITCHER_ENABLED,
  NEXT_PUBLIC_POWERED_BY_ENABLED:
    process.env.NEXT_PUBLIC_POWERED_BY_ENABLED ??
    process.env.EXPO_PUBLIC_POWERED_BY_ENABLED,
  NEXT_PUBLIC_CATEGORY_BUTTON_ENABLED:
    process.env.NEXT_PUBLIC_CATEGORY_BUTTON_ENABLED ??
    process.env.EXPO_PUBLIC_CATEGORY_BUTTON_ENABLED,
  NEXT_PUBLIC_VIDEO_OVERLAY_PLAYLIST_ENABLED:
    process.env.NEXT_PUBLIC_VIDEO_OVERLAY_PLAYLIST_ENABLED ??
    process.env.EXPO_PUBLIC_VIDEO_OVERLAY_PLAYLIST_ENABLED,
  NEXT_PUBLIC_DEFAULT_SUBTITLE_LANGUAGE:
    process.env.NEXT_PUBLIC_DEFAULT_SUBTITLE_LANGUAGE ??
    process.env.EXPO_PUBLIC_DEFAULT_SUBTITLE_LANGUAGE,
  NEXT_PUBLIC_SUBSCRIBE_URL:
    process.env.NEXT_PUBLIC_SUBSCRIBE_URL ??
    process.env.EXPO_PUBLIC_SUBSCRIBE_URL,
  NEXT_PUBLIC_LOAD_BITMOVIN_ON_EMBADDED_PATHS:
    process.env.NEXT_PUBLIC_LOAD_BITMOVIN_ON_EMBADDED_PATHS ??
    process.env.EXPO_PUBLIC_LOAD_BITMOVIN_ON_EMBADDED_PATHS,
  NEXT_PUBLIC_BODY_SCRIPT:
    process.env.NEXT_PUBLIC_BODY_SCRIPT ?? process.env.EXPO_PUBLIC_BODY_SCRIPT,
  NEXT_PUBLIC_FAVICON_URL:
    process.env.NEXT_PUBLIC_FAVICON_URL ?? process.env.EXPO_PUBLIC_FAVICON_URL,
  NEXT_PUBLIC_DEFAULT_AD_PROFILE_ID:
    process.env.NEXT_PUBLIC_DEFAULT_AD_PROFILE_ID ??
    process.env.EXPO_PUBLIC_DEFAULT_AD_PROFILE_ID,
  NEXT_PUBLIC_RELATED_PLAYLIST_ID:
    process.env.NEXT_PUBLIC_RELATED_PLAYLIST_ID ??
    process.env.EXPO_PUBLIC_RELATED_PLAYLIST_ID,
  NEXT_PUBLIC_GTM_ID:
    process.env.NEXT_PUBLIC_GTM_ID ?? process.env.EXPO_PUBLIC_GTM_ID,
  NEXT_PUBLIC_AD_RETRY_COUNT:
    process.env.NEXT_PUBLIC_AD_RETRY_COUNT ??
    process.env.EXPO_PUBLIC_AD_RETRY_COUNT,
  NEXT_PUBLIC_NEXT_VIDEO_OVERLAY_HIDE:
    process.env.NEXT_PUBLIC_NEXT_VIDEO_OVERLAY_HIDE ??
    process.env.EXPO_PUBLIC_NEXT_VIDEO_OVERLAY_HIDE,
  NEXT_PUBLIC_FORCE_SHOW_DEFAULT_HEADER:
    process.env.NEXT_PUBLIC_FORCE_SHOW_DEFAULT_HEADER ??
    process.env.EXPO_PUBLIC_FORCE_SHOW_DEFAULT_HEADER,
  NEXT_PUBLIC_CATCHUP_SECONDS:
    process.env.NEXT_PUBLIC_CATCHUP_SECONDS ??
    process.env.EXPO_PUBLIC_CATCHUP_SECONDS,
  NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL:
    process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL ??
    process.env.EXPO_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL,
  NEXT_PUBLIC_DEFAULT_CATEGORY_SORT_BY:
    process.env.NEXT_PUBLIC_DEFAULT_CATEGORY_SORT_BY ??
    process.env.EXPO_PUBLIC_DEFAULT_CATEGORY_SORT_BY,
  NEXT_PUBLIC_DEFAULT_ASSET_SORT_BY:
    process.env.NEXT_PUBLIC_DEFAULT_ASSET_SORT_BY ??
    process.env.EXPO_PUBLIC_DEFAULT_ASSET_SORT_BY,
  NEXT_PUBLIC_ENABLE_EYEVINN_AD_EVENTS:
    process.env.NEXT_PUBLIC_ENABLE_EYEVINN_AD_EVENTS ??
    process.env.EXPO_PUBLIC_ENABLE_EYEVINN_AD_EVENTS,
  NEXT_PUBLIC_EYEVINN_ANALYTICS_URL:
    process.env.NEXT_PUBLIC_EYEVINN_ANALYTICS_URL ??
    process.env.EXPO_PUBLIC_EYEVINN_ANALYTICS_URL,
  NEXT_PUBLIC_SHARD_ID:
    process.env.NEXT_PUBLIC_SHARD_ID ?? process.env.EXPO_PUBLIC_SHARD_ID,
  NEXT_PUBLIC_HEARTBEAT_INTERVAL:
    process.env.NEXT_PUBLIC_HEARTBEAT_INTERVAL ??
    process.env.EXPO_PUBLIC_HEARTBEAT_INTERVAL,
  NEXT_PUBLIC_EYEVINN_METADATA_FIELDS:
    process.env.NEXT_PUBLIC_EYEVINN_METADATA_FIELDS ??
    process.env.EXPO_PUBLIC_EYEVINN_METADATA_FIELDS,
  NEXT_PUBLIC_USE_IMAGE_BASED_PREVIEW:
    process.env.NEXT_PUBLIC_USE_IMAGE_BASED_PREVIEW ??
    process.env.EXPO_PUBLIC_USE_IMAGE_BASED_PREVIEW,
  NEXT_PUBLIC_PRIVACY_POLICY_URL:
    process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL ??
    process.env.EXPO_PUBLIC_PRIVACY_POLICY_URL,
  NEXT_PUBLIC_EMBEDDED_CMP_HEADER:
    process.env.NEXT_PUBLIC_EMBEDDED_CMP_HEADER ??
    process.env.EXPO_PUBLIC_EMBEDDED_CMP_HEADER,
  NEXT_PUBLIC_IS_CMP_ENABLED:
    process.env.NEXT_PUBLIC_IS_CMP_ENABLED ??
    process.env.EXPO_PUBLIC_IS_CMP_ENABLED,
  NEXT_PUBLIC_CMP_DEFAULT_ACCOUNT_ID:
    process.env.NEXT_PUBLIC_CMP_DEFAULT_ACCOUNT_ID ??
    process.env.EXPO_PUBLIC_CMP_DEFAULT_ACCOUNT_ID,
  NEXT_PUBLIC_DISABLE_INDEXING:
    process.env.NEXT_PUBLIC_DISABLE_INDEXING ??
    process.env.EXPO_PUBLIC_DISABLE_INDEXING,
  NEXT_PUBLIC_LIVEWRAPPED_ENABLED:
    process.env.NEXT_PUBLIC_LIVEWRAPPED_ENABLED ??
    process.env.EXPO_PUBLIC_LIVEWRAPPED_ENABLED,
  NEXT_PUBLIC_LIVEWRAPPED_TAG_ID:
    process.env.NEXT_PUBLIC_LIVEWRAPPED_TAG_ID ??
    process.env.EXPO_PUBLIC_LIVEWRAPPED_TAG_ID,
  NEXT_PUBLIC_LIVEWRAPPED_PUBLISHER_ID:
    process.env.NEXT_PUBLIC_LIVEWRAPPED_PUBLISHER_ID ??
    process.env.EXPO_PUBLIC_LIVEWRAPPED_PUBLISHER_ID,
  NEXT_PUBLIC_LIVEWRAPPED_GAM_AD_UNIT:
    process.env.NEXT_PUBLIC_LIVEWRAPPED_GAM_AD_UNIT ??
    process.env.EXPO_PUBLIC_LIVEWRAPPED_GAM_AD_UNIT,
  NEXT_PUBLIC_LIVEWRAPPED_AD_UNIT_NAME:
    process.env.NEXT_PUBLIC_LIVEWRAPPED_AD_UNIT_NAME ??
    process.env.EXPO_PUBLIC_LIVEWRAPPED_AD_UNIT_NAME,
  NEXT_PUBLIC_CD_ACCESS_KEY:
    process.env.NEXT_PUBLIC_CD_ACCESS_KEY ??
    process.env.EXPO_PUBLIC_CD_ACCESS_KEY,
  SITEMAP_USE_EMBEDDED_PLAYER_LOC: process.env.SITEMAP_USE_EMBEDDED_PLAYER_LOC,
} as const satisfies Record<string, string | undefined>;

const backupEnvVarGetter = (key: string) => {
  return envVarMap[key];
};

// Create a cache for consistent values
const envCache: Record<string, string | undefined> = {};

// Define an env getter that checks multiple sources
let env = (key: string): string | undefined => {
  // If we've already cached this value, use it for consistency
  if (envCache[key] !== undefined) {
    // console.log('Using cached value for env var:', key, envCache[key]);
    return envCache[key];
  }

  // Try window.__ENV first (client-side)
  if (
    typeof window !== 'undefined' &&
    '__ENV' in window &&
    window.__ENV?.[key]
  ) {
    // console.log('Found env var in window.__ENV:', key, window.__ENV[key]);
    envCache[key] = window.__ENV[key];
    return envCache[key];
  }

  // Try accessing the map for React Native compatibility
  if (envVarMap[key]) {
    // console.log('Found env var in envVarMap:', key, envVarMap[key]);
    envCache[key] = envVarMap[key];
    return envCache[key];
  }

  return undefined;
};

// Still try to import next-runtime-env for its utility functions, but only in web environments
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  // Only attempt to import next-runtime-env in web/Next.js environments
  import('next-runtime-env')
    .then((mod: { env: (key: string) => string | undefined }) => {
      // Update our getter to use next-runtime-env but with caching
      const nextEnv = mod.env;
      env = (key: string): string | undefined => {
        // If we've already cached this value, use it for consistency
        if (envCache[key] !== undefined) {
          return envCache[key];
        }

        // Try next-runtime-env first
        const value = nextEnv(key);
        if (value) {
          envCache[key] = value;
          return value;
        }

        // Try window.__ENV directly as backup (client-side)
        if (
          typeof window !== 'undefined' &&
          '__ENV' in window &&
          window.__ENV?.[key]
        ) {
          envCache[key] = window.__ENV[key];
          return envCache[key];
        }

        // Last resort: process.env
        envCache[key] = process.env[key];
        return envCache[key];
      };
    })
    .catch((err) => {
      console.error(
        'Error importing next-runtime-env. Using window.__ENV and process.env as fallbacks.',
        err,
      );
    });
}

// Extract known env var keys for intellisense
type KnownEnvVar = keyof typeof envVarMap;

export const getEnvVar = (
  key: KnownEnvVar | (string & {}),
): string | undefined => {
  if (key.includes('EXPO_PUBLIC_')) {
    key = key.replace('EXPO_PUBLIC_', 'NEXT_PUBLIC_');
  }
  // First check cache for consistent return values
  if (envCache[key] !== undefined) {
    return envCache[key];
  }

  const envVarGetterResult = env(key);

  // If env() returned a value (which is now also cached), return it
  if (envVarGetterResult) {
    // console.log('Found env var in env():', key, envVarGetterResult);
    return envVarGetterResult;
  }

  // If not, try the backup getter
  const backupEnvVarGetterResult = backupEnvVarGetter(key);
  if (backupEnvVarGetterResult) {
    // console.log(
    //   'Found env var in backupEnvVarGetter():',
    //   key,
    //   backupEnvVarGetterResult,
    // );
    envCache[key] = backupEnvVarGetterResult;
    return backupEnvVarGetterResult;
  }

  // Last resort: try direct map access again in case the previous checks missed it
  const mapValue = envVarMap[key as keyof typeof envVarMap];
  if (mapValue) {
    // console.log('Found env var in envVarMap:', key, mapValue);
    envCache[key] = mapValue;
    return mapValue;
  }

  // disabling the console warning for now so it doesn not clutter logs in production
  // console.warn(
  //   `Environment variable ${key} not found in env(), backupEnvVarGetter(), or envVarMap.`,
  // );

  // Cache the undefined result too
  envCache[key] = undefined;
  return undefined;
};
